import React from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import './countdownModal.css';

const CountDownModal = ({ isModalOpen, toggle, onIdle, handleStillThereClick }) => {
  const renderTime = ({ remainingTime }) => {
    if (remainingTime === 0 && isModalOpen) {
      onIdle();
    }
    return (
      <div className="timer">
        <div className="text">Remaining</div>
        <div className="value">{remainingTime}</div>
        <div className="text">seconds</div>
      </div>
    );
  };

  const handleComplete = () => {
    if (isModalOpen) {
      onIdle();
    }
  };

  return (
    <Modal isOpen={isModalOpen} toggle={toggle}>
      <ModalBody>
        <h5 className="modal-title-heading">You are going to get logged out due to inactivity</h5>

        <div className="timer-wrapper">
          <CountdownCircleTimer
            key={isModalOpen ? 'timer-active' : 'timer-inactive'}
            isPlaying={isModalOpen}
            duration={60}
            colors={[['#004777', 0.33], ['#F7B801', 0.33], ['#A30000']]}
            onComplete={handleComplete}
          >
            {renderTime}
          </CountdownCircleTimer>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleStillThereClick}>
          Still there?
        </Button>
      </ModalFooter>
    </Modal>
  );
};
export default CountDownModal;